import React from 'react'
import './Header.css'

const Navbar = (props) => {
   return (
      <nav className='navbar'>
         <div className='heading'>
            Word Analyze and Format
         </div>
      </nav>
   )
}

export default Navbar

